export const ERR_MSG_LNL_FETCH_FAILED = 'Error fetching from LNL API';
export const ERR_MSG_TT_FETCH_FAILED =
  'Error fetching from Texas Tribune Articles API';
export const GA_CATEGORY = 'read more';
export const GA_ACTION = 'lnl-recommendation';
export const GA_LABEL = 'story page';
export const LNL_BASE_URL = 'https://article-rec-api.localnewslab.io';
export const LNL_STATIC_PARAMS =
  'site=texas-tribune&model_type=article&sort_by=score';
